import React, { useEffect, useState } from "react";
import { APP } from "../../constant/theme";

const pad = (n) => String(n).padStart(2, "0");

const FlipDigits = ({ value }) =>
  String(value)
    .split("")
    .map((digit, index) => (
      <span key={`${digit}-${index}`} className="navbar-flip-digit">
        <span className="navbar-flip-digit-inner">{digit}</span>
      </span>
    ));

const formatTime = (date) => {
  let hours = date.getHours();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  return `${pad(hours)}:${pad(date.getMinutes())}:${pad(date.getSeconds())} ${ampm}`;
};

const NavbarClock = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!APP.navbarClock?.show) {
    return null;
  }

  const day = pad(now.getDate());
  const month = pad(now.getMonth() + 1);
  const year = String(now.getFullYear());

  return (
    <div className="navbar-clock" aria-live="polite">
      <div className="navbar-clock-time">{formatTime(now)}</div>
      <div className="navbar-clock-date" aria-label={`${day}/${month}/${year}`}>
        <FlipDigits value={day} />
        <span className="navbar-flip-sep">/</span>
        <FlipDigits value={month} />
        <span className="navbar-flip-sep">/</span>
        <FlipDigits value={year} />
      </div>
    </div>
  );
};

export default NavbarClock;
